import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILostReason, ILostReasonInitialState } from "./lostReasonModel";
import {
  ActiveInactiveLostReason,
  createLostReason,
  deleteLostReason,
  getAllActiveLostReasons,
  getAllLostReasons,
  getLostReasonByID,
  updateLostReason,
} from "./services/lostReason.services";

const initialState: ILostReasonInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  LostReasonList: [],
  LostReasonID: null,
  LostReasonDetail: {
    LostReason: "",
    IsActive: 1,
  },
};

const lostReasonSlice = createSlice({
  name: "lostReason",
  initialState,
  reducers: {
    clearLostReasonDetails: (state) => {
      state.LostReasonDetail = initialState.LostReasonDetail;
    },
    setLostReasonID: (state, action) => {
      state.LostReasonID = action.payload;
    },
    clearLostReasonID: (state) => {
      state.LostReasonID = initialState.LostReasonID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllLostReasons.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllLostReasons.fulfilled,
      (state, action: PayloadAction<ILostReason[]>) => {
        state.loading = false;
        state.LostReasonList = action.payload || [];
      },
    );
    builder.addCase(getAllLostReasons.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LostReasonList = [];
    });
    builder.addCase(createLostReason.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createLostReason.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createLostReason.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateLostReason.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateLostReason.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateLostReason.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteLostReason.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteLostReason.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteLostReason.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getLostReasonByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getLostReasonByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.LostReasonDetail = action.payload;
    });
    builder.addCase(getLostReasonByID.rejected, (state, action) => {
      state.formLoading = false;
      state.LostReasonDetail = initialState.LostReasonDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveLostReasons.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveLostReasons.fulfilled,
      (state, action: PayloadAction<ILostReason[]>) => {
        state.loading = false;
        state.LostReasonList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveLostReasons.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LostReasonList = [];
    });
    builder.addCase(ActiveInactiveLostReason.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveLostReason.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveLostReason.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearLostReasonDetails, clearLostReasonID, setLostReasonID } =
  lostReasonSlice.actions;
export default lostReasonSlice.reducer;
